// Styles for MapView go here.
import { baseVariables, contextualVariable, toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledMapView = styled.div`
  margin-left: ${toRem(-16)};
  margin-right: ${toRem(-16)};
  height: 70vh;
  @media only ${baseVariables.mediaQuery.md} {
    margin-left: unset;
    margin-right: unset;
  }

  position: relative;
  .gm-style-iw-chr {
    display: none;
  }

  .gm-style-iw-c {
    padding: 0;
  }

  .gm-style-iw-d {
    overflow: auto !important;
    padding: 0;
  }

  .loader-container {
    background: #f4f4f4;
    z-index: 999;
    width: 100%;
    position: absolute !important;
    top: 0;
    height: 70vh;
    margin: 0 auto;
    left: 0;
    right: 0;
    bottom: 0;
    border: ${toRem(1)} solid rgba(0, 0, 0, 0.5);
    border-radius: ${toRem(14)};
  }

  .gm-style-iw-tc::after {
    background: none;
  }

  .gm-style .gm-style-iw-c {
    border-radius: ${contextualVariable?.brandCardsBorderRadius} !important;
  }
`;
